// Shared Directory search: names, email and organization, active rows first.
export function searchDirectoryPeople(directory, query) {
  const q = String(query || "").trim().toLowerCase();
  return (directory || []).filter(p => p.active !== false)
    .filter(p => !q || [p.displayName, p.email, p.org].some(v => String(v || "").toLowerCase().includes(q)))
    .sort((a, b) => String(a.displayName || a.email).localeCompare(String(b.displayName || b.email)));
}
